<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    title="تنظیم ستون ها"
    :active.sync="popupActive"
  >
    <import-excel
      id="inputFile"
      ref="inputFile"
      :onSuccess="loadDataInTable"
      class="md:w-1/2"
      hidden
    />
    <div class="vx-row m-0 w-full">
      <div class="vx-col p-0 w-full">
        <div class="drag-container" v-drag-and-drop:options="options">
          <table class="cols-container">
            <th v-for="group in groups.slice(0, 4)" :key="group.id">
              {{ group.name }}
              <span
                class="group-error"
                v-if="
                  group.items.length > group.maxCount ||
                  group.items.length < group.minCount
                "
                >({{ group.error }})*</span
              >
            </th>
            <tr class="drag-list">
              <td
                class="drag-column group-nav"
                v-for="group in groups.slice(0, 4)"
                :key="group.id"
                :class="{
                  'group-nav-error':
                    group.items.length > group.maxCount ||
                    group.items.length < group.minCount,
                }"
              >
                <vue-draggable-group
                  v-model="group.items"
                  :groups="groups"
                  :data-id="group.id"
                >
                  <div
                    class="drag-inner-list w-full h-12 p-2 rounded-lg"
                    :data-id="group.id"
                  >
                    <vs-chip
                      v-for="item in group.items"
                      :key="item.id"
                      :data-id="item.id"
                      transparent
                      color="warning"
                      class="drag-item drag-item-text"
                      >{{ item.name }}</vs-chip
                    >
                  </div>
                </vue-draggable-group>
              </td>
            </tr>
          </table>
          <div class="vx-row m-0 mt-8 mb-2 w-full">
            <div class="vx-col p-0 w-full">
              جهت نمایش ستون ها زیر به مشتری آنها را کشیده و به ستون توضیحات در
              بالا اضافه کنید
            </div>
            <div class="vx-col p-0 w-full drag-list">
              <div
                class="drag-column group-nav"
                v-for="group in groups.slice(4, 5)"
                :key="group.id"
                :class="{
                  'group-nav-error':
                    group.items.length > group.maxCount ||
                    group.items.length < group.minCount,
                }"
              >
                <vue-draggable-group
                  v-model="group.items"
                  :groups="groups"
                  :data-id="group.id"
                >
                  <div
                    class="drag-inner-list w-full overflow-hidden p-2 rounded-lg"
                    :data-id="group.id"
                  >
                    <vs-chip
                      v-for="item in group.items"
                      :key="item.id"
                      :data-id="item.id"
                      transparent
                      color="warning"
                      class="drag-item drag-item-text"
                      >{{ item.name }}</vs-chip
                    >
                  </div>
                </vue-draggable-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="ok">تایید</vs-button>
        <vs-button
          color="warning"
          type="border"
          class="mb-2"
          @click="commissionGroup = {}"
          >انصراف</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>
<style lang="scss" scoped>
table {
  border: 1px solid #fff0f0;
  border-collapse: separate;
  width: 100%;
}
.group-nav {
  background: #eee;
  border: 1px solid #b7b6b6 !important;
  border-left-color: #b7b6b6 !important;
}
.group-nav-error {
  border-color: red;
}
.group-error {
  font-size: 0.7rem;
  color: red;
}
.cols-container {
  td {
    min-width: 10%;
    max-width: 50%;
  }
  th {
    text-align: left;
  }
}
.drag-inner-list {
  min-height: 80px;
}
</style>
<script>
import ImportExcel from "@/components/excel/ImportExcel.vue";
import VueDraggable from "vue-draggable";
import Vue from "vue";
Vue.use(VueDraggable);
export default {
  name: "bill-bull-upload-excel",
  components: {
    ImportExcel,
  },
  data() {
    return {
      popupActive: false,
      groups: this.getDefaultGroup(),
      options: {
        dropzoneSelector: ".drag-inner-list",
        draggableSelector: ".drag-item",
      },
      inputRows: [],
      mobileColName: "",
      amountColName: null,
      nameColName: null,
      nameColName2: null,
      descriptionHeaders: [],
    };
  },
  methods: {
    getDefaultGroup() {
      return [
        {
          id: 0,
          name: "شماره همراه",
          error: "شماره همراه باید یک آیتم باشد",
          minCount: 1,
          maxCount: 1,
          items: [],
        },
        {
          id: 1,
          name: "نام و نام خانوادگی",
          error: "نام و نام خانوادگی باید یک یا دو آیتم باشد",
          minCount: 0,
          maxCount: 2,
          items: [],
        },
        {
          id: 2,
          name: "مبلغ",
          error: "مبلغ باید صفر یا یک آیتم باشد",
          minCount: 0,
          maxCount: 1,
          items: [],
        },
        {
          id: 3,
          name: "توضیحات",
          error: "تعداد آیتمهای توضیحات باید بین صفر تا سه آیتم باشد",
          minCount: 0,
          maxCount: 3,
          items: [],
        },
        {
          id: 4,
          name: "حذف",
          minCount: 0,
          maxCount: 9999,
          items: [],
        },
      ];
    },
    browseFile() {
      this.groups = this.getDefaultGroup();
      this.$refs.inputFile.browseFile();
    },
    async loadDataInTable({ results, header /*, meta*/ }) {
      this.popupActive = true;
      this.inputRows = results;
      const headers = header;
      let loading = this.$vs.loading();
      //begin validate headers -----------------
      let errorCount = 0;
      if (results.length > 2000) {
        errorCount += 1;
        this.$vs.notify({
          time: 4000 + errorCount * 300,
          color: "danger",
          title: "اندازه فایل ",
          text: `تعداد ردیف های فایل وارد شده باید کمتر از 2000 ردیف باشد.`,
        });
      }
      const tempheaders = headers.map((x) => x.toLowerCase().replace(/ /g, ""));
      const mobileColNo = tempheaders.findIndex(
        (x) =>
          x.includes("mobile") ||
          x.includes("موبایل") ||
          x.includes("cellphone") ||
          x.includes("همراه")
      );
      if (mobileColNo == -1) {
        errorCount += 1;
        this.$vs.notify({
          time: 4000 + errorCount * 300,
          color: "danger",
          title: "فایل نامعتبر",
          text: `ستون تلفن همراه یافت نشده است.
        <br/>
         عنوان ستون باید تلفن همراه، تلفن همراه، Cell Phone و یا mobile  باشد.`,
        });
      }

      const amountColNo = tempheaders.findIndex(
        (x) => x.includes("مبلغ") || x.includes("amount") || x.includes("مقدار")
      );
      // if (amountColNo == -1) {
      //   errorCount += 1;
      //   this.$vs.notify({
      //     time: 4000 + errorCount * 300,
      //     color: "danger",
      //     title: "فایل نامعتبر",
      //     text: `ستون مبلغ یافت نشده است.
      //   <br/>
      //    عنوان ستون باید مبلغ و یا amount  باشد.`
      //   });
      // }

      const nameColNo = tempheaders.findIndex(
        (x) =>
          x.includes("نامونامخانوادگی") ||
          x.includes("نام") ||
          x.includes("فامیلی") ||
          x.includes("firstname") ||
          x.includes("lastname") ||
          x.includes("name") ||
          x.includes("family")
      );
      const nameColNo2 = tempheaders.findIndex(
        (x) =>
          x != tempheaders[nameColNo] &&
          (x.includes("نامونامخانوادگی") ||
            x.includes("نام") ||
            x.includes("فامیلی") ||
            x.includes("firstname") ||
            x.includes("lastname") ||
            x.includes("name"))
      );

      const descriptionNos = tempheaders.flatMap((x, i) =>
        x.includes("شناسه") || x.includes("شماره") ? [i] : []
      );

      //end validate headers ++++++++++++++++++
      let others = headers.filter(
        (x, i) =>
          ![
            mobileColNo,
            amountColNo,
            nameColNo,
            nameColNo2,
            ...descriptionNos,
          ].includes(i)
      );
      this.groups[0].items.push({
        id: 1,
        name: headers[mobileColNo],
        groupId: 0,
      });
      if (nameColNo >= 0) {
        this.groups[1].items.push({
          id: 2,
          name: headers[nameColNo],
          groupId: 1,
        });
      }
      if (nameColNo2 >= 0) {
        this.groups[1].items.push({
          id: 3,
          name: headers[nameColNo2],
          groupId: 1,
        });
      }
      if (amountColNo >= 0) {
        this.groups[2].items.push({
          id: 4,
          name: headers[amountColNo],
          groupId: 2,
        });
      }
      this.groups[3].items.push(
        ...descriptionNos.map((x, i) => {
          return {
            id: 5 + i,
            name: headers[x],
            groupId: 3,
          };
        })
      );
      this.groups[4].items.push(
        ...others.map((x, i) => {
          return {
            id: descriptionNos.length + 5 + i,
            name: x,
            groupId: 4,
          };
        })
      );
      await loading;
      this.$vs.loading.close();
    },
    ok() {
      if (this.groups[0].items.length != 1) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا",
          text: `برای تلفن همراه یک ستون انتخاب شود.`,
        });
        return;
      }
      if (this.groups[1].items.length > 2) {
        //|| this.groups[1].items.length == 0
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا",
          text: `برای نام و نام خانوادگی باید یک یا دو ستون انتخاب شود.`,
        });
        return;
      }
      if (this.groups[2].items.length > 1) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا",
          text: `برای مبلغ بیش از دو ستون انتخاب شده است.`,
        });
        return;
      }
      this.mobileColName = this.groups[0].items[0].name;
      this.nameColName = (this.groups[1].items[0] || {}).name;
      this.nameColName2 = (this.groups[1].items[1] || {}).name;
      this.amountColName = (this.groups[2].items[0] || {}).name;
      this.descriptionHeaders = this.groups[3].items.map((y) => y.name);

      if (!this.mobileColName) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا",
          text: `ستون تلفن همراه انتخاب نشده است.`,
        });
        return;
      }

      //begin validate values -----------------
      let validBills = [];
      let errorCount = 0;
      for (let i = 0; i < this.inputRows.length; i++) {
        let row = this.inputRows[i];
        let newRow = {};

        //mobile
        if (!this.validateMobile(row[this.mobileColName])) {
          errorCount += 1;
          this.$vs.notify({
            time: 4000 + errorCount * 300,
            color: "danger",
            title: "مقادیر نامعتبر",
            text: `تلفن همراه ردیف${i + 2} صحیح نمی باشد.`,
          });
        } else {
          let mobileNo = row[this.mobileColName].toString();
          if (mobileNo.length > 11) {
            mobileNo = ("a" + mobileNo)
              .replace(/ /g, "")
              .replace("a+98", "0")
              .replace("a98", "0")
              .replace("a0098", "0")
              .replace("a", "");
          }
          if (/^9\d{9}$/.test(mobileNo)) mobileNo = "0" + mobileNo;
          newRow["mobile"] = this.formatMobile(mobileNo);
        }
        //amount
        if (
          this.amountColName &&
          (isNaN(row[this.amountColName]) ||
            !this.validateAmount(row[this.amountColName]))
        ) {
          errorCount += 1;
          this.$vs.notify({
            time: 4000 + errorCount * 300,
            color: "danger",
            title: "مقادیر نامعتبر",
            text: `مبلغ ردیف ${i + 2} صحیح نمی باشد.`,
          });
        } else
          newRow["amount"] = this.amountColName
            ? this.formatAmount(row[this.amountColName])
            : "0";

        //name
        newRow["name"] = "";
        if (this.nameColName && row[this.nameColName] != undefined)
          newRow["name"] = row[this.nameColName];
        if (this.nameColName2 && row[this.nameColName2] != undefined)
          newRow["name"] += " " + row[this.nameColName2];

        //decription
        let description = {};
        for (let i = 0; i < this.descriptionHeaders.length; i++) {
          let x = this.descriptionHeaders[i];
          newRow[x] = row[x];
          description[x] = row[x];
        }
        if (JSON.stringify(description).length > 250) {
          errorCount += 1;
          this.$vs.notify({
            time: 4000 + errorCount * 300,
            color: "danger",
            title: "مقادیر نامعتبر",
            text: `متنهای اختیاری ردیف ${i + 2} بیش از طول مجاز می باشد.`,
          });
        }

        if (errorCount > 10) break;
        validBills.push(newRow);
      }
      //end validate values ++++++++++++++++++++

      if (errorCount == 0) {
        this.$emit("loadData", validBills, this.descriptionHeaders);
        this.popupActive = false;
      }
    },
    validateAmount(val) {
      val = val.toString().replace(/,/g, "");
      return /^[1-9]\d*$/.test(val);
    },
    formatAmount(val) {
      val = val.toString().replace(/,/g, "");
      if (isNaN(parseInt(val))) return val;
      else return parseInt(val).toLocaleString();
    },
    validateMobile(val) {
      val = val.toString().replace(/ /g, "");
      return /^(\+98|0|98|0098)?9\d{9}$/.test(val);
    },
    formatMobile(val) {
      val = val.toString().replace(/ /g, "");
      var result = val;
      if (val.length > 4) {
        result = val.slice(0, 4) + "  " + val.slice(4, 7);
        if (val.length > 7) result += "  " + val.slice(7, 11);
      }
      return result;
    },
  },
};
</script>
